import { type DesignSystemContext, DesignSystemContextProvider, Direction } from "@drone-js/core";
import { theme as droneAgodaTheme } from "@drone-js/theme-agoda";
import type { FunctionComponent, PropsWithChildren } from "react";

// @ts-expect-error drone tell to import ./styles.css but export defined as ./styles
import "@drone-js/theme/styles";
// @ts-expect-error drone tell to import ./theme.css but export defined as ./themes
import "@drone-js/theme/themes";

const context: DesignSystemContext = {
    theme: droneAgodaTheme,
    direction: Direction.LTR,
    experiment: {
        togglePositionSpecificityFix: true, // https://agoda.slack.com/archives/C67C3803D/p1789528777166609
        gridSizeFallback: true,
        alwaysMountTooltip: false,
        isZoomFontSizeFix: false,
        isMigratingChipToAccessibleColor: false,
        isMigratingBadgeToAccessibleColor: false,
        isMigratingNotificationToAccessibleColor: false,
        deprecateInaccessibleColor: false,
        isToggleButtonAccessibilityColorFix: false,
        isToggleButtonA11yContrastFix: false,
        iconsMigrationToV3: false,
        isGetDroneContextFromWindow: false,
        radioCheckboxA11yContrastFix: false,
        searchFieldMinHeight: false,
        incorrectInertAttrOnCarouselWhenResizing: false,
        radioCheckboxFocusStateContrastFix: false,
        carouselMigrationToV3: false,
        rurubuAccessibleColor: false,
        japanicanAccessibleColor: false,
        inputV2A11yBorderContrastFix: false,
        migrateDeprecatedColorTokenUsage: false,
        dropdownTriggerV2ComboboxRole: false,
        migrateColorPairAccessibleTokenUsage: false,
        accessibleInactiveBorder: false,
        iconAssetsMigrationToV3: false,
        migrateInputV2ToV3UI: false,
        inputTrailingAssetPaddingFix: false,
    },
};

export const DroneContext: FunctionComponent<PropsWithChildren> = (props) => (
    <DesignSystemContextProvider value={context} {...props} />
);
